module.exports = __webpack_public_path__ + "static/media/dest.fab47524.jpg";